import { atom } from 'jotai';

import { deviceColorOptionIdsAsyncAtom } from './deviceColorOptionIdsAsyncAtom';
import { deviceColorOptionIdsAtom } from './deviceColorOptionIdsAtom';

export const selectedDeviceColorOptionAsyncAtom = atom(async (get) => {
  const deviceColorOptionIds = get(deviceColorOptionIdsAtom);
  const colorOptions = await get(deviceColorOptionIdsAsyncAtom);

  const selectedDeviceColorOption = colorOptions?.find((option) =>
    option.option_ids.every((id) => deviceColorOptionIds?.includes(id))
  );
  return selectedDeviceColorOption;
});
